export var source_product_details_configurations = { "uid": "source_product_details_configurations", "fields": { "title": { "defaultValue": "" }, "cfh_id": { "defaultValue": "" } } };
